import { useContext } from "react";
import { Navigate } from "react-router-dom";
import { ProfileContext } from "../context/ProfileContext";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useContext(ProfileContext);

  if (loading) return null; 

  if (!user) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default ProtectedRoute;
